import { render, staticRenderFns } from "./RichTextArea.vue?vue&type=template&id=b1e4bdc6&"
import script from "./RichTextArea.vue?vue&type=script&lang=ts&"
export * from "./RichTextArea.vue?vue&type=script&lang=ts&"
import style0 from "./RichTextArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports